// @flow
export { default } from './BrandToc';



// WEBPACK FOOTER //
// ./src/components/brand/BrandToc/index.js